import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { staggerVariants, VIEWPORT_ONCE_TIGHT } from "../lib/motion";

const cardVariants = staggerVariants({ y: 20, duration: 0.5, step: 0.08 });

function PreviewCard({ post, index }) {
    return (
        <motion.article
            data-testid={`blog-preview-card-${post.slug}`}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            custom={index}
            viewport={VIEWPORT_ONCE_TIGHT}
            className="group rounded-2xl overflow-hidden bg-[#0A0E23] border border-white/5 hover:border-[#A6E3DC]/30 transition"
        >
            <Link to={`/blogs/${post.slug}`} className="block">
                <div className="aspect-[16/10] overflow-hidden">
                    <img
                        src={post.cover_image}
                        alt={post.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition duration-700"
                    />
                </div>
                <div className="p-6">
                    <div className="flex items-center gap-3 text-xs text-slate-500 mb-3">
                        <span className="text-[#A6E3DC] font-bold tracking-wider uppercase">
                            {post.category}
                        </span>
                        <span>·</span>
                        <span>{post.read_minutes} min read</span>
                    </div>
                    <h3 className="text-lg font-bold text-white tracking-tight leading-snug group-hover:text-[#A6E3DC] transition">
                        {post.title}
                    </h3>
                    <p className="text-slate-400 text-sm mt-3 leading-relaxed line-clamp-2">
                        {post.excerpt}
                    </p>
                </div>
            </Link>
        </motion.article>
    );
}

export default function BlogPreview({ posts = [] }) {
    if (!posts.length) return null;
    const visible = posts.slice(0, 3);

    return (
        <section
            data-testid="blog-preview-section"
            className="relative py-24 lg:py-32"
        >
            <div className="xpo-container">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
                    <SectionHeading
                        overline="Insights"
                        title="Notes from the desk."
                        description="Macro takes, MT5 walkthroughs, and the boring discipline that compounds."
                    />
                    <Link
                        to="/blogs"
                        data-testid="blog-preview-view-all"
                        className="btn-outline-mint self-start lg:self-auto"
                    >
                        View all <ArrowRight size={16} />
                    </Link>
                </div>

                <div className="grid md:grid-cols-3 gap-6">
                    {visible.map((p, i) => (
                        <PreviewCard key={p.id} post={p} index={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}
